'use client';

import { c as _c } from "react/compiler-runtime";
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { Container, Section, SectionHeader, Card, MotionBlock } from './shared';
import { motion } from 'framer-motion';
import { stagger, fadeUp } from '@/lib/animations';
export function ProblemSection() {
  const $ = _c(24);
  const c = useCadrinoCopy();
  let t0;
  if ($[0] !== c.problem.subtitle || $[1] !== c.problem.title) {
    t0 = <MotionBlock><SectionHeader title={c.problem.title} subtitle={c.problem.subtitle} /></MotionBlock>;
    $[0] = c.problem.subtitle;
    $[1] = c.problem.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== c.problem.cards) {
    t1 = c.problem.cards.length > 0 && <motion.div className="mt-6 grid gap-5 md:grid-cols-3" variants={stagger} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: "-80px"
    }}>{c.problem.cards.map(_temp)}</motion.div>;
    $[3] = c.problem.cards;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = c.problem.cards.length > 0 ? "mt-7" : "mt-5";
  let t3;
  if ($[5] !== c.problem.agitationTitle) {
    t3 = <h3 className="text-xl font-semibold text-slate-900">{c.problem.agitationTitle}</h3>;
    $[5] = c.problem.agitationTitle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== c.problem.agitationIntro) {
    t4 = <p className="mt-3 text-sm text-cadrino-muted">{c.problem.agitationIntro}</p>;
    $[7] = c.problem.agitationIntro;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== c.problem.agitationItems) {
    t5 = c.problem.agitationItems.map(_temp2);
    $[9] = c.problem.agitationItems;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <ul className="mt-6 space-y-3">{t5}</ul>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <Card className="border-cadrino-accent/20 bg-cadrino-surface">{t3}{t4}{t6}</Card>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t7) {
    t8 = <MotionBlock className={t2}>{t7}</MotionBlock>;
    $[17] = t2;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t0 || $[21] !== t1 || $[22] !== t8) {
    t9 = <Section id="problem" className="py-12 md:py-16"><Container>{t0}{t1}{t8}</Container></Section>;
    $[20] = t0;
    $[21] = t1;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
function _temp2(item) {
  return <li key={item} className="flex gap-3 text-sm text-slate-700 before:mt-2 before:h-1 before:w-1 before:shrink-0 before:rounded-full before:bg-cadrino-accent before:content-['']">{item}</li>;
}
function _temp(card) {
  return <motion.div key={card.title} variants={fadeUp}><Card className="h-full"><h3 className="text-lg font-semibold text-slate-900">{card.title}</h3><p className="mt-3 text-sm leading-relaxed text-cadrino-muted">{card.description}</p></Card></motion.div>;
}